// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import TitleTypography, { TitleTypographyStyles } from "@tps/App/Components/Common/TitleTypography";
import { XngCustomGroup } from "@tps/XDL/constants";
import { color, xScreen } from "@tps/XDL/Utilities";
import { FC } from "react";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        firstName: state.context.session.firstName,
        isAuthenticated: state.context.session.isAuthenticated && !state.context.session.isGuest,
    }
}

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

interface UserQuickLinksStyles {
    wrapper?: InjectableCss;
    titleTypographyStyles?: TitleTypographyStyles;
}

const UserQuickLinksStyles: UserQuickLinksStyles = {
    titleTypographyStyles: {
        wrapper: {
            css: css`
                justify-content: space-between;
                border-bottom: 1px solid ${color("common.border")};
                margin: 0;
                padding-bottom: 8px;
                ${xScreen("lt", "sm")} {
                    margin: 0;
                    gap: 8px;
                }
            `
        },
        title: {
            variant: "h3",
        },
    }
};

const styles = UserQuickLinksStyles;

const UserQuickLinks: FC<Props> = ({ firstName, myAccountPageLink, isAuthenticated }) => {
    if (!isAuthenticated) {
        return null;
    }
    return (
        <TitleTypography
            link={myAccountPageLink?.url}
            linkText={translate("View Dashboard")}
            extendedStyles={styles.titleTypographyStyles}
            data-test-selector="UserQuickLinks"
        >
            {translate("Welcome")}, {firstName}
        </TitleTypography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(UserQuickLinks),
    definition: {
        group: XngCustomGroup,
    },
};

export default widgetModule;
